// extracted by mini-css-extract-plugin
export default {"permanents":"permanents_permanents__n20Ii","content":"permanents_content__WmPI+"};